import React from 'react';
import { LeadsListPage } from './LeadsListPage';

export function LostListPage() {
  return <LeadsListPage defaultStatus="DISQUALIFIED" />;
}
